// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArchivedCampaigns":"pv_a bht_qt bht_a bht_w bht_ea","ArchivedCampaigns__date":"pv_b bht_vv bht_ry bht_fo"};